import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data);
      navigate("/dashboard");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-12 bg-[#0A0A0A]">
      <div className="w-full max-w-md bg-[#12161d] border border-white/10 rounded-2xl shadow-2xl p-8 animate-fade-up">
        <div className="flex justify-center mb-6">
          <img src="/guardlink-logo.jpg" alt="GuardLink" className="h-20 w-auto rounded-xl" />
        </div>
        <h1 className="font-head text-2xl font-bold tracking-tight text-white text-center">{t("login_title")}</h1>
        {error && <div data-testid="login-error" className="mt-4 text-sm bg-red-500/10 text-red-400 border border-red-500/30 rounded-md px-3 py-2">{error}</div>}
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Field label={t("email")}><input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0A0A0A] border border-white/15 text-white rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#E11D2A] placeholder-zinc-500" /></Field>
          <Field label={t("password")}><input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#0A0A0A] border border-white/15 text-white rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#E11D2A] placeholder-zinc-500" /></Field>
          <button data-testid="login-submit" disabled={loading} className="w-full bg-[#E11D2A] text-white hover:bg-[#B0121F] font-bold rounded-md py-3 transition-colors disabled:opacity-60">{loading ? t("loading") : t("submit")}</button>
        </form>
        <p className="mt-6 text-sm text-zinc-400 text-center">{t("no_account")} <Link data-testid="to-register" to="/register" className="text-[#E11D2A] font-semibold hover:text-[#ff4d5a]">{t("register_title")}</Link></p>
      </div>
    </div>
  );
}

const Field = ({ label, children }) => (
  <div><label className="block text-sm font-medium text-zinc-300 mb-1.5">{label}</label>{children}</div>
);
